import { Avatar, Button, Drawer, PopperButton, Divider } from "@pinkyhead/dovekit";
import { ReactComponent as UserIcon } from "../../../../assets/icons/regular/user.svg";
import { useUser } from "./User.hooks"
import { DrawerContainer, LoginButton, UserContainer } from "./User.styles";

export const User = () => {
  const {
    drawerOpen,
    drawerShow,
    redirectToLoginPage,
    toggleDrawerOpen,
    user,
    logout,
    redirectToCoreProfile
  } = useUser();
  return (
    <>
      {user
        ?
          <>
            <div onClick={toggleDrawerOpen}>
              <Avatar 
                size={60}
                fontSize={18}
                displayName={user.displayName}
                picture={null}
              />
            </div>
            <Drawer
              toggleDrawerOpen={toggleDrawerOpen}
              drawerOpen={drawerOpen}
              drawerShow={drawerShow}
            >
              <DrawerContainer>
                <UserContainer>
                  <Avatar 
                    size={60}
                    fontSize={18}
                    displayName={user.displayName}
                    picture={null}
                  />
                  <h3>{user.displayName}</h3>
                </UserContainer>
                <PopperButton onClick={redirectToCoreProfile}>
                  Redirect to DoveMed Profile
                </PopperButton>
                <Divider />
                <Button
                  fullWidth
                  onClick={logout}
                  variant="secondary"
                >
                  Logout
              </Button>
              </DrawerContainer>
            </Drawer>
          </>
        :
          <LoginButton onClick={redirectToLoginPage}>
            <UserIcon />
          </LoginButton>
      }
    </>
  )
}
